<template>
  <v-dialog
    v-model="show"
    width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loadingData ? true : false"
  >
    <v-card>
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-row no-gutters class="px-2">
        <v-col cols="11">
          <v-card-title
            class="no-break text-h5 text-center justify-center font-weight-bold"
          >
            {{ cdTitle }}
          </v-card-title>
        </v-col>
        <v-col cols="1" class="justify-end">
          <v-icon
            v-if="Object.keys(item).length == 0"
            ref="cancel"
            data-testid="cancel-button"
            min-width="100"
            class="rounded-xxl text-none my-6"
            @click="show = false"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="Object.keys(item).length == 0 ? addFile() : editFile()"
          @submit.prevent
        >
          <p class="text-body-2 greytext--text mb-2 ml-5">
            {{ $t("labelTitle") }}
          </p>
          <v-text-field
            v-model="title"
            data-testid="title-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2"
            :placeholder="cdInputPlaceholder"
            :rules="titleRules"
          />
          <div>
            <p class="text-body-2 greytext--text mb-2 ml-5">
              {{ $t("labelUploadFile") }}
            </p>
            <v-file-input
              ref="attach_file"
              v-model="fileData"
              data-testid="attachment-input"
              :disabled="loadingUpload"
              hide-input
              class="d-none"
              accept="image/png, image/jpeg, .pdf, .ppt, .pptx, .doc, .docx, .xls, .xlsx, .odt, .csv, .ods, .rtf, .txt"
              @change="uploadFile"
            />
            <v-btn
              :loading="loadingUpload"
              data-testid="upload-button"
              mx-auto
              color="grey"
              class="rounded-xxl text-none white--text px-10"
              elevation="2"
              @click="showUploadFile"
            >
              {{ $t("uploadFile") }}
            </v-btn>
          </div>
          <div v-if="fileData == null" class="px-6">
            <span
            style="color: var(--v-error-base)" class="text-caption">{{ alertMsgRequired }}</span> 
          </div>
          <v-row no-gutters class="py-4" v-if="attachment">
            <v-col cols="1" class="justify-center d-flex">
              <span
                :style="`color: ` + attachmentIcon.color"
                :class="`mdi mdi-24px ` + attachmentIcon.icon"
                >&nbsp;</span
              >
            </v-col>
            <v-col cols="10">
              <v-clamp autoresize :max-lines="1" class="text-caption">
                {{ attachmentTitle }}
              </v-clamp>
            </v-col>
            <v-col cols="1" class="justify-end d-flex">
              <v-btn
                v-if="attachment"
                data-testid="delete-comment-button"
                icon
                small
                class=""
                @click.stop="removeHubFile()"
              >
                <v-icon small color="black"> mdi-close </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card-actions class="px-0 pt-0">
            <v-spacer />
            <v-btn
              v-if="Object.keys(item).length > 0"
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4 mb-2 mb-md-0"
              :class="{'disable-events': loadingData}"
              @click="show=false"
            >
              {{ $t('cancel') }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="add-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none"
              :loading="loadingData"
              @click="Object.keys(item).length == 0 ? addFile() : editFile()"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from "../rules/formRules.js";
import i18n from "../plugins/i18n";
import { uploadHubFile, removeHubFile, addHubAttachment, updateHubAttachment } from "../api/hubApi";
import VClamp from "vue-clamp";
import AlertMessages  from './AlertMessages'
export default {
  components: {
    VClamp,
    AlertMessages
  },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdText: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: "",
    },
    cdInputPlaceholder: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      valid: true,
      titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
      title: "",
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false,
      loadingUpload: false,
      fileData: null,
      loadingFile: false,
      buttonDisabled: false,
      hubID: this.$route.params.id,
      spaceId: window.$cookies.get("space_id"),
      attachment: null,
      attachmentIcons: [
        { type: "jpeg", color: "#00C853", icon: "mdi-file-jpg-box" },
        { type: "jpg", color: "#00C853", icon: "mdi-file-jpg-box" },
        { type: "png", color: "#2962FF", icon: "mdi-file-png-box" },
        { type: "pdf", color: "#ff1744", icon: "mdi-file-pdf-box" },
        { type: "ppt", color: "#FBC02D", icon: "mdi-file-powerpoint-outline" },
        { type: "pptx", color: "#FBC02D", icon: "mdi-file-powerpoint-outline" },
        { type: "doc", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "docx", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "xls", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "xlsx", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "odt", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "csv", color: "#00C853", icon: "mdi-file-delimited-outline" },
        { type: "ods", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "rtf", color: "#7C8386", icon: "mdi-file-document-outline" },
        { type: "txt", color: "#7C8386", icon: "mdi-file-document-outline" },
      ],
      attachmentIcon: {},
      attachmentExtension: "",
      attachmentTitle: "",
      alertMsgRequired:"",
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
          this.$refs.form.reset();
        }
      },
    },
  },
  created(){
    if(Object.keys(this.item).length > 0){
      this.title = this.item.attributes.title
      this.attachment = this.item.attributes.attachment_path
      this.attachmentExtension = this.item.attributes.attachment_ext
      this.attachmentTitle = this.item.attributes.attachment_title
      this.attachmentIcon =
        this.attachmentIcons[
          this.attachmentIcons.findIndex(
            (item) => item.type == this.attachmentExtension
          )
        ];
        this.fileData = {name:this.item.attributes.attachment_title}
    } 
  },
  methods: {
    async addFile() {
      this.valid = this.$refs.form.validate();
      if(this.fileData == null) {
        this.alertMsgRequired  = i18n.t("attachmentErrorRequired");
        return
      }
      if (this.valid) {
        this.loadingData = true;
        try {
          let data = {
            data: {
              type: "hub-attachments",
              attributes: {
                title: this.title.trim(),
                url: this.attachment,
              },
              relationships: {
                hub: {
                  data: {
                    type: "hubs",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          const response = await addHubAttachment(data);
          if (response) {
            if (response.status == 201) {
              this.show = false;
              this.$emit("proceedSubmit", 'add-file');
              this.$refs.form.reset();
              
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 422 ){
                for(let i = 0; i < e.response.data.errors.length; i++){
                    if(e.response.data.errors[i].detail == 'The url field is required.'){
                        this.alertMsgRequired = i18n.t("attachmentErrorRequired");
                    }else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg = i18n.t('serverError')
                    }
                }
            }else if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t("serverError");
            }
          } else {
            this.alertValue = true
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
          //this.$emit("proceedSubmit", this.alertMsg, this.alertType);
        }
        this.loadingData = false;
      }
    },
    async editFile(){
      this.valid = this.$refs.form.validate();
      if(this.fileData == null) {
        this.alertMsgRequired  = i18n.t("attachmentErrorRequired");
        return
      }
      if (this.valid) {
        this.loadingData = true;
        try {
          let data = {
            data: {
              type: "hub-attachments",
              id: this.item.attributes.entity_id,
              attributes: {
                title: this.title.trim(),
                url: this.attachment,
              },
              relationships: {
                hub: {
                  data: {
                    type: "hubs",
                    id: this.$route.params.id,
                  },
                },
              },
            },
          };
          const response = await updateHubAttachment(this.item.attributes.entity_id, data);
          if (response) {
            if (response.status == 200) {
              this.show = false;
              this.$emit("proceedSubmit");
              this.$refs.form.reset();
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 422 ){
                for(let i = 0; i < e.response.data.errors.length; i++){
                    if(e.response.data.errors[i].detail == 'The url field is required.'){
                        this.alertMsgRequired = i18n.t("attachmentErrorRequired");
                    }else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg = i18n.t('serverError')
                    }
                }
            }else if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t("serverError");
            }
          } else {
            this.alertValue = true
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
          //this.$emit("proceedSubmit", this.alertMsg, this.alertType);
        }
        this.loadingData = false;
      }
    },
    showUploadFile() {
      this.$refs.attach_file.$refs.input.click();
    },
    loading() {
      if (this.loadingUpload || this.buttonDisabled) {
        return true;
      }
      return false;
    },
    async uploadFile() {
      if (this.fileData) {
        if (this.fileData.size > 50 * 1024 * 1024) {
          this.fileData = null
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t("uploadDocumentSizeError");
          
        } else {
          this.loadingUpload = true;
          this.buttonDisabled = true;
          try {
            let data = new FormData();
            data.append("type", "hub_attachment");
            data.append("file", this.fileData);
            data.append("space_id", this.spaceId);
            const response = await uploadHubFile(this.$route.params.id, data);
            if (response.status == 200) {
              this.attachment = response.data.meta.detail;
              this.attachmentExtension = response.data.meta.detail
                .split(".")
                .pop();
              this.attachmentTitle = response.data.meta.detail.split("/").pop();
              this.attachmentIcon =
                this.attachmentIcons[
                  this.attachmentIcons.findIndex(
                    (item) => item.type == this.attachmentExtension
                  )
                ];
              this.loadingUpload = false;
            }
          } catch (e) {
             if(e.response){
                  this.alertType = 'error'
                    if (e.response.status == 422) {
                      for (let i = 0; i < e.response.data.errors.length; i++) {
                        this.alertValue = true
                        this.alertType = "error";
                        if (
                          e.response.data.errors[i].meta[0].code ==
                          "extensionUnsupported"
                        ) {
                          this.alertMsg = i18n.t("uploadDocumentExtensionError");
                          
                        } else {
                          this.alertMsg = i18n.t("serverError");
                        }
                      }
                    } else if (e.response.status == 403) {
                          this.$router.push({ name: "PageAccessDenied" });
                    } else {
                      this.alertValue = true
                      this.alertType = "error";
                      this.alertMsg = i18n.t("serverError");
                    }
              }else{
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
              }   
          }
          this.loadingUpload = false;
          this.buttonDisabled = false;
        }
      }
      this.$refs.attach_file.$refs.input.value = ''
    },
    async removeHubFile() {
      if(Object.keys(this.item).length > 0){
        this.attachment = null;
        this.fileData = null;
        this.attachmentTitle = "";
        this.attachmentIcon = "";
        this.attachmentExtension = "";
      }else {
        try {
          let data = {
            data: {
              type: "hub-attachments",
              attributes: {
                path: this.attachment,
              },
            },
          };
          const response = await removeHubFile(this.$route.params.id, data);
          if (response.status == 200) {
            this.attachment = null;
            this.fileData = null;
            this.attachmentTitle = "";
            this.attachmentIcon = "";
            this.attachmentExtension = "";
          }
        } catch (e) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.$emit("proceedSubmit", this.alertMsg, this.alertType);
        }
      }
    },
  },
};
</script>